import * as React from 'react';
import LinkWrapper from '@common/components/linkWrapper';
import { useParams } from 'react-router';
import Profile from '../../../../common/components/profile';
import mergeNamesText from '../../../../common/utils/merged-names-text';

const AnalyticsUserCount = ({ item }) => {
  const { networkId } = useParams();
  const baseUrl = networkId ? `/networks/${networkId}` : '/admin';

  return (
    <div className="AnalyticsUser">
      <LinkWrapper url={`${baseUrl}/users/${item.user.id}/about`} className="hover:tw-underline tw-w-full hover:tw-text-inherit">
        <Profile
          enablePopover
          user={{ profile_img: item.user.profileImg, full_name: item.user.fullName }}
        >
          <small>{mergeNamesText(item.user.networks, 3, 'name')}</small>
        </Profile>
      </LinkWrapper>
      <div className="AnalyticsUser__Count">{item.count}</div>
    </div>
  );
};

export default AnalyticsUserCount;
